import { localStorageGet } from '@Infra/LocalStorage';
import { LOCAL_STORAGE_KEYS } from '@Infra/LocalStorage/keys';

/**
 * Synchronous, not a thunk: `CurrentOrganizationProvider` needs the persisted identifier at the same
 * tick it reads the freshly resolved assignments list, to run its validation in a single pass. Anything
 * that is not a well-formed positive integer — no value yet, malformed content, a leftover non-numeric
 * string — resolves to `null`: a corrupted key never throws, it just reads as "nothing persisted",
 * which the caller always treats as safe to recompute.
 */
const readCurrentOrganization = (): number | null => {
	const rawOrganizationId = localStorageGet(LOCAL_STORAGE_KEYS.CURRENT_ORGANIZATION_ID);

	if (rawOrganizationId === null) {
		return null;
	}

	const parsedOrganizationId = Number(rawOrganizationId);

	if (!Number.isInteger(parsedOrganizationId) || parsedOrganizationId <= 0) {
		return null;
	}

	return parsedOrganizationId;
};

export default readCurrentOrganization;
